import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    paper: {
      width: '200px',
      backgroundColor: 'transparent',
    },
    outerGridPopOver: {
      backgroundColor: '#383838',
      borderRadius: 8,
      marginTop: 10,
      '& .minWidthPopOver': {
        minWidth: '100%',
      },
    },
    buttonBgPopOver: {
      backgroundColor: 'rgba(42, 171, 63, 0.08)',
    },
    commonTextPopOver: {
      width: '100%',
      letterSpacing: '0.5px',
      textAlign: 'start',
    },
    selectedColorPopOver: {
      color: 'rgba(42, 171, 63, 1)',
    },
    deSelectedColorPopOver: {
      color: 'rgba(255, 255, 255, 0.87)',
    },
    popoverArrow: {
      letterSpacing: '0.5px',
      color: 'rgba(255, 255, 255, 0.87)',
      textAlign: 'end',
    },
  }),
);

export default useStyles;
